<template>
  <div class="kpb-grid" :style="`gap: ${gap}; align-items: ${alignItems}; grid-template-columns: ${columnsComp}`">
    <slot />
  </div>
</template>

<script>
/** Layout component for splitting content into a grid. */
export default {
  props: {
    columns: {
      type: [Number, String],
      default: 2,
    },
    gap: {
      type: String,
      default: '1rem',
    },
    alignItems: String,
  },
  computed: {
    columnsComp() {
      if (typeof this.columns === 'number') return `repeat(${this.columns}, 1fr)`

      if (this.columns.startsWith('auto')) return `repeat(${this.columns});`
      const cols = this.columns.split(':')
      return cols.map(col => `${col}fr`).join(' ')
    },
  },
}
</script>

<style lang="scss">
.kpb-grid {
  display: grid;

  @include respond-below('phone') {
    grid-template-columns: 1fr !important;

    * {
      grid-column: unset !important;
      grid-row: unset !important;
    }
  }
}
</style>
